(function () {
  const root = document.getElementById('CeliaCartRoot');
  const drawer = document.getElementById('CeliaCartDrawer');
  const overlay = document.getElementById('CeliaCartOverlay');
  const itemsBox = document.getElementById('CeliaCartItems');
  const subtotalBox = document.getElementById('CeliaCartSubtotal');
  const summarySubtotal = document.getElementById('CeliaSummarySubtotal');
  const summaryDiscount = document.getElementById('CeliaSummaryDiscount');
  const countBox = document.getElementById('CeliaCartCount');
  const progressBar = document.getElementById('CeliaProgressBar');
  const shippingText = document.getElementById('CeliaShippingText');
  const shippingAmount = document.getElementById('CeliaShippingAmount');
  const upsellList = document.getElementById('CeliaUpsellList');
  const checkoutButton = document.getElementById('CeliaCheckoutButton');

  if (!root || !drawer || !overlay) return;

  const threshold = Number(root.dataset.freeShippingThreshold || 0);
  const enableRecentlyViewed = root.dataset.enableRecentlyViewed === 'true';

  function money(cents) {
    return (cents / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    });
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-active');
    drawer.setAttribute('aria-hidden', 'false');
    loadCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-active');
    drawer.setAttribute('aria-hidden', 'true');
  }

  window.CeliaOpenCart = openDrawer;
  window.CeliaCloseCart = closeDrawer;

  document.addEventListener('click', function (event) {
    const cartLink = event.target.closest('a[href="/cart"], a[href*="/cart"]');

    if (cartLink) {
      event.preventDefault();
      openDrawer();
      return;
    }

    if (
      event.target.closest('.cm-cart-close') ||
      event.target === overlay
    ) {
      closeDrawer();
      return;
    }

    const qtyButton = event.target.closest('[data-celia-qty]');
    if (qtyButton) {
      changeQuantity(
        qtyButton.getAttribute('data-key'),
        Number(qtyButton.getAttribute('data-quantity'))
      );
      return;
    }

    const removeButton = event.target.closest('[data-celia-remove]');
    if (removeButton) {
      changeQuantity(removeButton.getAttribute('data-key'), 0);
      return;
    }

    const upsellButton = event.target.closest('[data-celia-upsell-add]');
    if (upsellButton) {
      addUpsell(upsellButton.getAttribute('data-variant-id'));
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('form[action="/cart/add"]')) return;

    event.preventDefault();

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form)
    })
      .then(openDrawer)
      .catch(function () {
        form.submit();
      });
  });

  if (checkoutButton) {
    checkoutButton.addEventListener('click', function () {
      window.location.href = '/checkout';
    });
  }

  function loadCart() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        renderUpsells(cart);
      });
  }

  function changeQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        renderCart(cart);
        renderUpsells(cart);
      });
  }

  function addUpsell(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    }).then(loadCart);
  }

  function renderCart(cart) {
    const subtotal = cart.original_total_price || cart.total_price;
    const total = cart.total_price;
    const discount = subtotal - total;

    if (subtotalBox) subtotalBox.textContent = money(total);
    if (summarySubtotal) summarySubtotal.textContent = money(subtotal);
    if (summaryDiscount) summaryDiscount.textContent = discount > 0 ? '-' + money(discount) : money(0);
    if (countBox) countBox.textContent = cart.item_count;

    renderShipping(cart);

    if (!itemsBox) return;

    if (!cart.items || cart.items.length === 0) {
      itemsBox.innerHTML = `
        <div class="cm-empty">
          <h3>Your cart is empty.</h3>
          <a href="/collections/all">Explore New Arrivals</a>
        </div>
      `;
      return;
    }

    itemsBox.innerHTML = cart.items.map(function (item) {
      const hasDiscount = item.original_line_price > item.final_line_price;
      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? item.variant_title
        : '';

      return `
        <div class="cm-cart-item">
          <a href="${item.url}">
            <img src="${item.image || ''}" alt="${escapeHtml(item.product_title)}">
          </a>

          <div>
            <p class="cm-item-title">${escapeHtml(item.product_title)}</p>

            <div class="cm-item-prices">
              ${
                hasDiscount
                  ? `<span class="cm-compare-price">${money(item.original_line_price)}</span>`
                  : ''
              }
              <span class="${hasDiscount ? 'cm-final-price' : ''}">
                ${money(item.final_line_price)}
              </span>
            </div>

            ${
              variantTitle
                ? `<div class="cm-item-variant">ONE SIZE <span>${escapeHtml(variantTitle)}</span></div>`
                : ''
            }

            <div class="cm-item-actions">
              <div class="cm-qty">
                <button type="button" data-celia-qty data-key="${item.key}" data-quantity="${item.quantity - 1}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-celia-qty data-key="${item.key}" data-quantity="${item.quantity + 1}">+</button>
              </div>

              <div class="cm-item-icons">
                <button type="button" class="cm-icon-btn" aria-label="Save item">♡</button>
                <button type="button" class="cm-icon-btn" aria-label="Remove item" data-celia-remove data-key="${item.key}">×</button>
              </div>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function renderShipping(cart) {
    if (!threshold || !progressBar) return;

    const percent = Math.min((cart.total_price / threshold) * 100, 100);
    progressBar.style.width = percent + '%';

    if (!shippingText || !shippingAmount) return;

    if (cart.total_price >= threshold) {
      shippingText.textContent = 'You unlocked free shipping';
      shippingAmount.textContent = '';
    } else {
      shippingText.textContent = "You're";
      shippingAmount.textContent = money(threshold - cart.total_price) + ' away from free shipping';
    }
  }

  function getManualUpsells() {
    const script = document.getElementById('CeliaManualUpsells');
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function saveRecentlyViewed() {
    const script = document.getElementById('CeliaCurrentProduct');
    if (!script) return;

    try {
      const product = JSON.parse(script.textContent);

      if (!product || !product.handle || !product.variantId) return;

      let viewed = JSON.parse(localStorage.getItem('celia_recently_viewed') || '[]');

      viewed = viewed.filter(function (item) {
        return item.handle !== product.handle;
      });

      viewed.unshift(product);
      viewed = viewed.slice(0, 12);

      localStorage.setItem('celia_recently_viewed', JSON.stringify(viewed));
    } catch (error) {}
  }

  function renderUpsells(cart) {
    if (!upsellList) return;

    const cartHandles = cart.items.map(function (item) {
      return item.handle;
    });

    const manualUpsells = getManualUpsells();

    const recentlyViewed = enableRecentlyViewed
      ? JSON.parse(localStorage.getItem('celia_recently_viewed') || '[]')
      : [];

    let products = recentlyViewed.concat(manualUpsells).filter(function (product) {
      return product && product.variantId && !cartHandles.includes(product.handle);
    });

    const seen = new Set();

    products = products.filter(function (product) {
      if (seen.has(product.handle)) return false;
      seen.add(product.handle);
      return true;
    }).slice(0, 10);

    if (!products.length) {
      upsellList.innerHTML = '';
      return;
    }

    upsellList.innerHTML = products.map(function (product) {
      const hasCompare = product.comparePrice && product.comparePrice !== product.price;

      return `
        <div class="cm-upsell-card">
          <div class="cm-upsell-image-wrap">
            <a href="${product.url}">
              <img src="${product.image}" alt="${escapeHtml(product.title)}">
            </a>
            ${hasCompare ? '<span class="cm-upsell-sale">SALE</span>' : ''}
          </div>

          <div class="cm-upsell-info">
            <p class="cm-upsell-title">${escapeHtml(product.title)}</p>

            <div class="cm-upsell-prices">
              ${hasCompare ? `<span class="cm-upsell-compare">${product.comparePrice}</span>` : ''}
              <span class="cm-upsell-price">${product.price}</span>
            </div>
          </div>

          <button type="button" class="cm-upsell-add" data-celia-upsell-add data-variant-id="${product.variantId}">
            +
          </button>
        </div>
      `;
    }).join('');
  }

  function escapeHtml(text) {
    if (!text) return '';

    return text
      .toString()
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  saveRecentlyViewed();
})();